import request from '@/utils/request'

export function getPlatforms() {
  return request({
    url: '/api/config/platforms',
    method: 'get'
  })
}
